<template>
    <div class="app-container pa-4">
        <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
        <v-row>
            <v-col sm="auto" class="hidden-sm-and-down">
                <component-sidebar
                        :attribute-system-name="attribute"
                        :system-name="systemValue"
                        :id="componentSystemValue"
                        :total="total"
                        @update-list="updateList"
                        v-if="!isMobile"
                ></component-sidebar>
            </v-col>
            <v-col>
                <div>
                    <h1 class="text-center" v-if="metaData.header">{{ metaData.header }}</h1>
                    <div v-if="!metaData.header">
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                    </div>
                    <v-col cols="12">
                        <div class="skeleton-text-short" v-if="listLoading">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                        </div>
                        <div class="overline text-center" v-else>{{$t('productsFound')}}: {{total}}</div>
                    </v-col>
                    <div class="d-flex justify-space-between justify-md-end">
                        <mobile-filters
                            v-if="isMobile"
                            :attribute-system-name="attribute"
                            :attribute-id="componentSystemValue"
                            :attribute-name="componentSystemName"
                            :filter-key="filterKey"
                            :total="total"
                            @update-list="updateList"
                        ></mobile-filters>
                        <sort-products @apply-sort="applySort"></sort-products>
                    </div>
                    <product-list-chips
                            :items="productChips"
                            :chips-key="filterKey"
                            @update-list="updateList"
                    ></product-list-chips>
                    <product-list
                            :loading="listLoading"
                            :products="products"
                            :total="total"
                            :init-page="page"
                            :last-page="lastPage"
                            :is-visible-more-button="loadMore"
                            filter-card-key="attribute"
                            @show-more="incrementPage"
                            @change-page="setPage"
                    ></product-list>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import AppBreadcrumbs from '../../../app-front/mixins/AppBreadcrumbs';
    import ComponentSidebar from './AttributeSidebar';
    import Breadcrumbs from '../../../app-front/components/breadcrumbs';
    import Meta from '../../../app-front/mixins/Meta';
    import MobileFilters from "../../../app-front/components/filters/MobileFilters";
    import ProductList from '../../../app-front/components/product/product-list';
    import ProductListChips from '../../../app-front/components/product/product-list-chips';
    import ProductListSort from '../../../app-front/mixins/ProductListSort';
    import SortProducts from "../../../app-front/components/product/sort"
    import ProductsPagination from '../../../app-front/mixins/ProductsPagination';

    export default {
        name: "ProductAttribute",
        props:['attribute', 'systemValue'],
        mixins:[
            AppBreadcrumbs,
            Meta,
            ProductListSort,
            ProductsPagination
        ],
        components:{
            Breadcrumbs,
            ProductList,
            ProductListChips,
            ComponentSidebar,
            MobileFilters,
            SortProducts
        },
        data() {
            return {
                breadcrumbsData: {
                    page: 'attributePage',
                    data:{
                        attribute: this.attribute,
                        value: this.systemValue
                    }
                },
                filterKey: 'attribute',
                metaUrl: `/products/attribute-value/${this.attribute}/${this.systemValue}`,
            }
        },
        computed: {
            isMobile() {
                return window.innerWidth <= 959;
            },
            filters() {
                return this.$store.state.filters[this.filterKey];
            },
            componentSystemName() {
                return this.attribute.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
            },
            componentSystemValue() {
                return this.systemValue;
            },
            productChips() {
                return this.$store.state.chips[this.filterKey];
            },
        },
        methods: {
            reset(){
                this.$store.commit('resetChips', {key: this.filterKey});
                this.updateMetaUrl();
                this.getMetaData();
                this.updateBreadcrumbs();
                this.products = [];
                this.page = 1;
            },
            beforeProductsRequest() {
                this.$store.commit('resetChips', this.filterKey)
            },
            updateBreadcrumbs(){
                this.breadcrumbsData.data.attribute = this.attribute;
                this.breadcrumbsData.data.value = this.componentSystemValue;
                this.setBreadcrumbs();
            },
            updateList() {
                this.updateProducts();
            },
            updateMetaUrl() {
                this.metaUrl = `/products/attribute-value/${this.attribute}/${this.systemValue}`;
            },
        },
        created() {
            this.$store.commit('resetChips', this.filterKey)

        },
        watch: {
            componentSystemValue() {
                this.reset();
            }
        }
    }
</script>

<style scoped>

</style>
